import checkRange from './check-range';
import contrastRatio from './contrast-ratio';
import extractSpectrumFromHex from './extract-spectrum-from-hex';
import findClosestGoldenPalette from './find-closest-golden-palette';
import generatePalette from './generate-palette';
import generateAccentPalette from './generate-accent-palette';
import generateDarkPalette from './generate-dark-palette';
import generateLightPalette from './generate-light-palette';
import kb from './kb';
import mapPaletteArrayToObject from './map-palette-array-to-object';
import minMax from './min-max';
import normalizeRGB from './normalize-rgb';
import sRGBAssume from './srgb-assume';
import roundsDecimals from './rounds-decimals';

export default {
  checkRange,
  contrastRatio,
  extractSpectrumFromHex,
  findClosestGoldenPalette,
  generatePalette,
  generateAccentPalette,
  generateDarkPalette,
  generateLightPalette,
  kb,
  mapPaletteArrayToObject,
  minMax,
  normalizeRGB,
  sRGBAssume,
  roundsDecimals,
};
